export default __webpack_public_path__ + "static/media/socialvid.98cdfda5.png";